/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import Typography from '@egalite/ui/Typography';
import Link from 'next/link';
import Icon from '@egalite/ui/Icon';
import IconButton from '@egalite/ui/Buttons/IconButton';

const DisabilityBlock = ({ disability, link }) => (
	<div className='border-solid border-2 border-brand-main rounded-lg bg-brand-light h-[120px] my-14 flex items-center justify-center p-8 '>
		<div css={{ flex: '1 0 auto', marginLeft: 15 }}>
			<Typography xStyle={{ marginBottom: 4, fontWeight: 700 }} color="brand.dark" variant="body2">
				{disability}
			</Typography>
		</div>
		
		<Link href={link} className="print:hidden">
			<IconButton
				title={`Editar deficiência`}
				icon={
					<Icon
						className="fi fi-br-edit-alt text-[1.6rem] text-base-grey-5 hover:text-brand-main transition-all duration-500"
					></Icon>
				}
				border={true}
				className="text-base-grey-5 rounded-full h-[4.4rem] w-[4.4rem] border-base-grey-5 border-2 hover:border-brand-main transition-all duration-500"
			/>
		</Link>
	</div>
);

export default DisabilityBlock;
